<template>
  <v-menu
    ref="menu"
    v-model="showMenu"
    :close-on-content-click="false"
    :return-value.sync="localTimeValue"
    @input="handleMenuClose"
    offset-y
    max-width="290px"
    min-width="290px"
    disable-keys
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="localTimeValue"
        outlined
        prepend-inner-icon="mdi-clock-outline"
        placeholder="Select a time"
        :label="label"
        readonly
        v-bind="{...$attrs, ...attrs}"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="showMenu"
      v-model="localTimeValue"
      no-title

    >
      <v-spacer />
      <div class="d-flex">
        <v-btn
          text
          @click="cancel"
          class="mr-3"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="saveValue"
          class="primary"
        >
          OK
        </v-btn>
      </div>
    </v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'TimePicker',
  data() {
    return {
      showMenu: false,
      localTimeValue: null
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Time'
    }
  },
  created() {
    if (this.value) {
      const d = new Date(this.value);
      if (d) {
        // re-format iso date/time obj to local date
        // e.g. UTC ISO date string, "2020-01-01T23:00:00Z" will be ~9am in AEST
        this.localTimeValue = `${d.getHours()}:${d.getMinutes().toString().padStart(2, '0')}`;
      } else {
        // trust the data passed in is in the correct format
        this.localTimeValue = this.value;
      }
    }
  },
  watch: {
    localTimeValue(val) {
      // emit the change for pseudo two way binding
      this.$emit('input', val);
    }
  },
  methods: {
    cancel() {
      this.showMenu = false;
    },
    handleMenuClose(wasOpened) {
      // save when closed by clicking outsideC
      if (!wasOpened) {
        this.saveValue();
      }
    },
    saveValue() {
      // save the value
      this.$refs.menu.save(this.localTimeValue);
    }
  },
}
</script>

<style scoped lang="scss">

</style>
